export default __webpack_public_path__ + "static/media/bg-farmer-life.b94566df.svg";